const actions = {
    // wsData
    wsDataMu({ commit }, data) {
        commit("wsData", data);
    },
};

export default actions;